// @ts-nocheck
// 导入 axios
import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router/index.js';
// import { refreshTokenApi } from '@/api/login.js'

// 导入 工具函数
import { getToken, removeToken } from '@/utils/token.js';
console.log('RequestUrl', window.RequestUrl);

const request = axios.create({
  baseURL: window.RequestUrl,
});

// 拦截器
request.interceptors.request.use(
  function (config) {
    let token = getToken();
    if (token != null) {
      var newToken = JSON.parse(token);
      // if(newToken == null)
      // console.log('authorization', config.headers.isAuth);
      // if (config.headers.isAuth == false) {
      // }
      config.headers.authorization = 'Bearer ' + newToken.accessToken;
    }
    // console.log('配置参数：', config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应  拦截器(回调函数)
request.interceptors.response.use(
  function (res) {
    // 对响应的数据 做 一些 事情
    if (res.data.code !== 200) {
      return Message.error(res.data.message || res.data.Message);
    }
    return res.data;
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 就刷新token
          // var token = getToken()
          // if(!token) return router.push("/login");
          // var newToken = JSON.parse(token)
          // refreshTokenApi(newToken.refreshToken).then(res => {
          //   window.console.log('刷新token')
          //   window.console.log(res)
          //   // 返回空就说明许久未登陆，清除token重新登陆
          //   if(res.data.accessToken === null) {
          //     Message.error("超时已退出!");
          //     removeToken();
          //     setTimeout(() => {
          //       router.push("/login");
          //     }, 1000);
          //   }else {
          //     // 刷新成功，就更新本地token
          //     saveToken(JSON.parse(res.data))
          //   }
          // }).catch(() => {
          Message.error('超时已退出!');
          removeToken();
          setTimeout(() => {
            router.push('/login');
          }, 1000);
          // })
          break;
        default:
          return Message.error(error.response.message);
      }
    }
    return Promise.reject(error.response); // 返回接口返回的错误信息
  }
);

// 暴露出去
// 把创建出来的 请求对象 暴露出去
export default request;
